<template>
    <v-form ref="form" v-model="valid" lazy-validation>
    <v-card flat>
            <v-card-text>

                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>

                <h3>Nova imóvel</h3>
                    <v-container fluid grid-list-lg>
                        <v-layout row wrap>

                            <v-flex xl12 lg12 md12 sm12 xs12>
                            <v-btn flat class="primary right" @click.stop="addtag = true">Adicionar Tags</v-btn>
                            </v-flex>

                            <v-flex xl6 lg6 md12 sm12 xs12>
                                <v-text-field
                                        v-model="fields.name"
                                        :rules="nameRules"
                                        label="Título"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="fields.bpm"
                                        :rules="nameRules"
                                        label="BPM"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="fields.keyword"
                                        :rules="nameRules"
                                        label="Key"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        required
                                        v-model="fields.category_id"
                                        :items="categories"
                                        item-value="id"
                                        item-text="name"
                                        label="Categoria"
                                ></v-select>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        required
                                        v-model="fields.subcategory_id"
                                        item-value="id"
                                        item-text="name"
                                        :items="subcategories"
                                        label="Subcategoria"
                                ></v-select>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        flat
                                        solo
                                        v-model="fields.tags"
                                        :items="tags"
                                        item-text="tag"
                                        chips
                                        placeholder="Clique aqui para associar tags"
                                        multiple
                                        return-object
                                ></v-select>
                            </v-flex>

                            <v-flex xl12 lg12 md12 sm12 xs12>
                                <uploads :fields="fields" :url="'/add-medias.json'"></uploads>
                            </v-flex>

                            <v-flex xl12 lg12 md12 sm12 xs12>
                                <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                            </v-flex>

                        </v-layout>
                    </v-container>
            </v-card-text>

        <v-dialog v-model="addtag" persistent max-width="50%">
            <v-card>
                <v-card-text>
                    <v-flex xl12 lg12 md12 sm12 xs12>
                        <v-form ref="formTags" v-model="valid" lazy-validation>
                        <v-text-field
                                v-model="tag"
                                :rules="nameRules"
                                label="Nome da Tag"
                                required
                        ></v-text-field>
                        </v-form>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  color="write darken-1" class="secondary" flat @click.native="addtag = false">Fechar</v-btn>
                    <v-btn  color="write darken-1" class="primary" flat @click.native="addTags">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        </v-card>
    </v-form>
</template>

<script>
    import Uploads from "../../components/Uploads";
    export default {
        name: 'medias-add',
        components: {Uploads},
        data: () => ({
            fields: {
                tags: [],
            },
            categories:[],
            subcategories:[],
            valid: true,
            error: false,
            success: false,
            addtag: false,
            messages: '',
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ],
            tags: [],
            tag: '',
        }),
        methods: {
            clear() {
                this.$router.push('/')
            },
            getCategoriesFromApi() {
                var self = this
                self.axios.get('/get-categories.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.categories = response.data
                })
            },
            getSubCategoriesFromApi() {
                var self = this
                self.axios.get('/get-subcategories.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.subcategories = response.data
                })
            },
            getTagsFromApi() {
                var self = this
                self.axios.get('/get-tags.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.tags = response.data
                })
            },
            addTags(){
                var self = this
                self.success = false
                self.error = false
                self.messages = ''
                self.loading = true
                if (this.$refs.formTags.validate()) {
                    self.$store.commit('setLoading', true)
                    self.axios.post('/add-tags.json', {tag: self.tag}, {
                        headers: {
                            'Authorization': self.$store.state.token
                        }
                    }).then(function (response) {
                        self.$store.commit('setLoading', false)
                        if (response.data.success === true) {
                            self.tags = response.data.tags
                            self.messages = response.data.messages
                            self.success = true
                        } else {
                            self.error = true
                            self.messages = response.data.messages
                        }
                    })
                }
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getCategoriesFromApi()
                this.getSubCategoriesFromApi()
                this.getTagsFromApi()
            })
        }
    }
</script>
